exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".logo[data-v-f853fd96]{position:relative;text-indent:-3000px;pointer-events:none;width:56px;height:calc(var(--LINE-HEIGHT) * 2);color:var(--BLACK)}.logo[data-v-f853fd96]:before{width:25.3px;height:25.3px;top:calc(var(--LINE-HEIGHT) - 12.65px);border-radius:100%;left:0}.logo[data-v-f853fd96]:after,.logo[data-v-f853fd96]:before{content:\" \";position:absolute;background-color:currentColor}.logo[data-v-f853fd96]:after{width:19.6px;height:19.6px;top:calc(var(--LINE-HEIGHT) - 9.8px);left:33px;transform:rotate(45deg)}@media only screen and (max-width:576px){.logo[data-v-f853fd96]{width:46px}.logo[data-v-f853fd96]:before{width:21.2px;height:21.2px;top:calc(var(--LINE-HEIGHT) - 10.6px)}.logo[data-v-f853fd96]:after{width:16.6px;height:16.6px;left:27.88px;top:calc(var(--LINE-HEIGHT) - 8.3px)}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f853fd96","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Logo.vue
// module id = 103
// module chunks = 0